import React, { useState, useEffect } from "react";
import usersService from "../main/body/screens/IAM/Users/users.service";

const PhysicianColumn = ({ item }: { item: any }) => {
  const [fullName, setFullName] = useState<string>(item.assignedEms);

  const getFullName = async (emsid: string) => {
    try {
      const userResponse = await usersService.listUsersByUsername(emsid);
      if (userResponse.length > 0) {
        console.log("Doctor full name", userResponse[0]);
        let fullname = "";
        if (userResponse[0]?.name || userResponse[0]?.family_name) {
          const fname = userResponse[0]?.name ?? "";
          const lname = userResponse[0]?.family_name ?? "";
          fullname = `${fname} ${lname}`;
        }
        return fullname || emsid;
      } else {
        console.log("No user found with username:", emsid);
        return emsid;
      }
    } catch (error) {
      console.log("Error fetching user data:", error);
      return emsid;
    }
  };

  useEffect(() => {
    const fetchFullName = async () => {
      const name = await getFullName(item.assignedEms);
      setFullName(name);
    };

    fetchFullName();
  }, [item.assignedEms]);

  return <div>Dr. {fullName}</div>;
};

export default PhysicianColumn;